<ng-container *transloco="let t">
  @if (applicationFromSettings && (visibilityKey || registrationDisplayFlagKey || requiredKey)) {
    <div [ngbTooltip]="tooltip">
      <div class="dropdown-panel" (click)="openModal(content)">
        <app-race-details-panel [title]="title" [panelStatus]="panelStatus" [disabled]="disabled"
                                [panelId]="registrationDisplayFlagKey + '.' + visibilityKey  +'.'+ requiredKey"
        >
          <div class="panel-content">
            <strong class="mb-3 d-inline-block fs-18 trim-text pe-20 line-height-12">{{ title }}</strong>
            <div [ngClass]="{'pb-3': !visibilityKey}" class="d-flex">
              <small class="pb-1 {{
                  modelHolder?.registrationDisplayFlag === RegistrationDisplayFlags.ALWAYS_USED ? 'fw-bold' : ''
                }}">
                {{
                  registrationDisplayFlagKey ?
                    t('race.registration.settings.registrationDisplayFlags.' +
                      (modelHolder?.registrationDisplayFlag ?? RegistrationDisplayFlags.NOT_USED)
                    ) : ''
                }}
              </small>


              @if (registrationDisplayFlagKey ? t('race.registration.settings.registrationDisplayFlags.' + (modelHolder?.registrationDisplayFlag ?? RegistrationDisplayFlags.NOT_USED)) : '' === '') {
                <small class="pb-1"><br/></small>
              }
            </div>
            <small>{{
                visibilityKey ? t('race.settings.visibilityTypes.' + (modelHolder?.visibility
                  ??
                  VisibilityTypes.NOT_VISIBLE)) : ''
              }}</small>
          </div>
        </app-race-details-panel>
      </div>
      <ng-template #content>
        <div class="row p-3">
          @if (registrationDisplayFlagKey || requiredKey) {
            <div [class.col-12]="true" [class.col-xxl-6]="visibilityKey"
                 [class.col-xxl-12]="!visibilityKey">
              <!-- Radio buttons for registrationDisplayFlag -->
              @if (registrationDisplayFlagKey) {
                <div class="form-group pb-3">
                  <label class="d-block fw-bold pb-2">{{
                      t("race.registration.settings.registrationDisplayFlags")
                    }}</label>
                  @for (flag of registrationDisplayFlags;track flag) {
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="radio" class="form-check-input" [name]="registrationDisplayFlagKey"
                               [disabled]="registrationDisplayFlagSelectionDisabled" [value]="flag.id"
                               [ngModel]="modelHolder?.registrationDisplayFlag ?? RegistrationDisplayFlags.NOT_USED"
                               (ngModelChange)="setField(registrationDisplayFlagKey, $event)">
                        {{ t("race.registration.settings.registrationDisplayFlags." + flag.id) }}
                      </label>
                    </div>
                  }
                </div>
              }
              @if (requiredKey) {
                <div class="form-check form-switch mb-4">
                  <input class="form-check-input borderBlock" type="checkbox" [id]="requiredKey" style="scale: 0.85;"
                         [disabled]="!fieldUsed || requiredSelectionDisabled" [ngModel]="modelHolder?.required"
                         (ngModelChange)="setField(requiredKey, $event)">
                  <label class="form-check-label text-muted" style="scale: 0.85;">
                    {{ t("race.registration.settings.required") }}
                  </label>
                </div>
              }
            </div>
          }
          @if (visibilityKey) {
            <div [class.col-12]="true" [class.col-xxl-6]="registrationDisplayFlagKey || requiredKey"
                 [class.col-xxl-12]="!(registrationDisplayFlagKey || requiredKey)"
                 [ngClass]="{'xxl-border-start': registrationDisplayFlagKey || requiredKey}">
              <!-- Radio buttons for visibility -->
              <div class="form-group pb-3">
                <label class="d-block fw-bold pb-2">{{ t("race.registration.settings.visibility") }}</label>
                @for (visibility of visibilityTypes;track visibility) {
                  <div class="form-check">
                    <label class="form-check-label">
                      <input type="radio" class="form-check-input" [name]="visibilityKey"
                             [disabled]="!fieldUsed || visibilitySelectionDisabled"
                             [value]="visibility.id"
                             [ngModel]="modelHolder?.visibility ?? VisibilityTypes.NOT_VISIBLE"
                             (ngModelChange)="setField(visibilityKey, $event)">
                      {{ t("race.settings.visibilityTypes." + visibility.id) }}
                    </label>
                  </div>
                }
              </div>
            </div>
          }
          @if (textFieldKey && textFieldKeyEng && textFieldKeySlo && textFieldKeyIta && textFieldKeySr && textFieldKeyBs) {
            <div class="col-12 mt-2">
              <!-- Textarea for text multilang field -->
              <app-language-input [inputForm]="multiLangForm" [required]="false" [hrKey]="'textCro'"
                                  [enKey]="'textEng'" [srKey]="'textSr'" [bsKey]="'textBs'"
                                  [itKey]="'textIta'" [siKey]="'textSlo'" [hrLabel]="textFieldPlaceholderPrefix"
                                  [enLabel]="textFieldPlaceholderPrefix.concat('.en')"
                                  [srLabel]="textFieldPlaceholderPrefix.concat('.sr')"
                                  [bsLabel]="textFieldPlaceholderPrefix.concat('.bs')"
                                  [itLabel]="textFieldPlaceholderPrefix.concat('.it')"
                                  [siLabel]="textFieldPlaceholderPrefix.concat('.sl')"/>
            </div>
          }
          @if (optionsKey) {
            <div class="col-12 mt-2">
              <!-- Multi-select dropdown for options-->
              <div class="form-group">
                <label class="d-block fw-bold pb-2">{{ fieldLabel }}</label>
                <app-multiselect-dropdown [options]="options"
                                          [required]="fieldUsed"
                                          [ngModel]="modelHolder?.options"
                                          [disabled]="!fieldUsed"
                                          (ngModelChange)="setField(optionsKey, $event)"
                                          [dropdownLabel]="dropdownLabel"
                                          [openDropdownUpwards]="(options.size ?? 0)>4"/>
              </div>
            </div>
          }
        </div>
      </ng-template>
    </div>
  }
</ng-container>
